// @ts-nocheck

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import 'font-awesome/css/font-awesome.css';

import { BootstrapVue3 } from 'bootstrap-vue-3';

const app = createApp(App);

app.use(router);        
app.use(BootstrapVue3);

if (process.env.NODE_ENV === 'production') {
  app.config.errorHandler = (err, vm, info) => {
    console.error('Erro capturado:', err);
  };

  app.config.devtools = false;
  app.config.productionTip = false;
}

router.isReady().then(() => {
  app.mount('#app');
});
